import calculateTransform from './calculateTransform.js';

/**
 * Get transform of enabled element
 *
 * @param {object} enabledElement - Enabled element
 * @returns {*} transform
 */
function getTransform(enabledElement) {
  // For now we will calculate it every time it is requested.
  // In the future, we may want to cache it in the enabled element to speed things up.
  return calculateTransform(enabledElement);
}

export default getTransform;
